import moment from 'moment'
import { Recurring } from 'types/event'
import { Activity } from 'types/user'
import { Event } from 'types/event'
import { Interest } from 'types/interest'
import { getMonthFromNumber } from './dateTime'
import { isDev } from 'app/general'
import { localeTexts } from 'locale/texts'

export const createCardsFromInterests = (eventInterests: string[], allInterests: Interest[]) => {
  let i = eventInterests.map((x) => allInterests.find((y) => y.title.toLowerCase() === x.toLowerCase())).filter(x => x) as Interest[]
  return i.map((x) => {
    x.active = true
    return x
  })
}

export const getDay = (date: number) => {
  const day = moment(new Date(date)).format('DD')
  if (isNaN(parseInt(day))) return " "
  return day
}

export const getMonth = (date: number) => {
  const month = moment(new Date(date)).format('M')
  if (isNaN(parseInt(month))) return " "
  return getMonthFromNumber(parseInt(month))
}

export const isEventLiked = (eventId: string, activity: Activity) => {
  const result = activity.likedEventsIds
    ? activity.likedEventsIds.includes(eventId)
    : false
  return result
}
export const isEventAttended = (eventId: string, activity: Activity) => {
  const result = activity.attendingEventsIds
    ? activity.attendingEventsIds.includes(eventId)
    : false
  return result
}

export const getRecurringEndDate = (startDate: number, endDate: number, recurringStartDate: number) => {
  try {
    const diffInDays = moment(new Date(startDate)).diff(moment(new Date(endDate)), 'days')
    if (diffInDays === 0) {
      return recurringStartDate
    }
    const recurringEndDate = moment(new Date(recurringStartDate)).add(diffInDays, 'days')
    return recurringEndDate.valueOf()
  } catch (e) {
    console.error("getRecurringEndDate", e)
    return endDate
  }
}

export const getRecurringStartDate = (event: Event, cDate?: string) => {

  const startDate = parseInt(event.startDate)
  try {
    if (cDate === undefined) return startDate;
    if (event.recurring === Recurring.NONE) return startDate;
    const contextDate = moment(new Date(parseInt(cDate)));
    const eventDate = moment(new Date(startDate))
    const diff = contextDate.diff(eventDate, 'days')
    if (diff <= 0) return startDate
    // if (isDev) console.log("getRecurringStartDate", { diff, c: contextDate.format("DD:MMM"), e: eventDate.format("DD:MMM") })

    if (event.recurring === Recurring.WEEKLY) {
      const nextDays = (diff % 7)
      const nextEventDate = moment().add((7 - nextDays), 'days')
      if (nextEventDate.isBefore(contextDate)) return startDate;
      return nextEventDate.valueOf()
    }

    if (event.recurring === Recurring.MONTHLY) {
      const day = getDay(startDate)
      const nextEventDate = moment().day(day)
      if (!nextEventDate) return startDate;

      if (nextEventDate.isBefore(contextDate)) nextEventDate.add(1, "month")
      if (!nextEventDate) return startDate;
      if (nextEventDate.isBefore(contextDate)) return startDate;

      return nextEventDate.valueOf()
    }

    if (event.recurring === Recurring.DAILY) {
      const nextEventDate = moment();
      if (nextEventDate.isBefore(contextDate)) return startDate;
      return nextEventDate.valueOf()
    }

    return startDate
  } catch (e) {
    console.error("getRecurringStartDate", e)
    return startDate
  }
}

export const getRecurringText = (event: Event) => {
  switch (event?.recurring) {
    case Recurring.DAILY: return localeTexts.event.recurringDaily;
    case Recurring.WEEKLY: return localeTexts.event.recurringWeekly;
    case Recurring.MONTHLY: return localeTexts.event.recurringMonthly;
    default: return "";
  }
};

export const sortEventsByStartDate = (events: Event[]) => {
  return events.sort((a, b) => parseInt(b.startDate) - parseInt(a.startDate))
}